import React from 'react';

import { useIntl } from '../../util/reactIntl';

import OptionCard from './OptionCard';

import css from './MultiQuestionStep.module.css';

function MultiQuestionStep({
  question,
  selected,
  updateAnswer,
}) {
  const intl = useIntl();

  const toggle = option => {
    let values = [...selected];

    if (option.exclusive) {
      values = [option.value];
    } else {
      values = values.filter(v => v !== 'none');

      if (values.includes(option.value)) {
        values = values.filter(v => v !== option.value);
      } else {
        values.push(option.value);
      }
    }

    updateAnswer(question.id, values);
  };

  return (
    <div className={css.root}>
      <div className={css.question}>
        {intl.formatMessage({
          id: question.title,
        })}
      </div>

      <div className={css.optionsContainer}>
        {question.options.map(option => (
          <OptionCard
            key={option.value}
            label={intl.formatMessage({
              id: option.label,
            })}
            subtitle={intl.formatMessage({
              id: option.subtitle,
            })}
            selected={selected.includes(option.value)}
            variant="large"
            onClick={() => toggle(option)}
          />
        ))}
      </div>
    </div>
  );
}

export default MultiQuestionStep;